
import { api } from "./api";

// Service to handle saving progress to backend
export const saveGameProgress = async (
    score: number,
    subject: string,
    topic: string,
    difficulty: string,
    totalQuestions: number,
    correctCount: number,
    isTimed: boolean
) => {
    
    // Calculate Points
    let points = score * 10;
    if (difficulty === 'Hard') points *= 2;
    if (isTimed) points += 20;

    try {
        await api.post('/quiz/history', {
            score,
            subject,
            topic,
            difficulty,
            totalQuestions,
            correctCount,
            points
        });
        return { success: true, pointsEarned: points };
    } catch (e) {
        console.error("Failed to save progress", e);
        return { success: false, pointsEarned: 0 };
    }
};
